<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary secondary--text" style="word-break: normal">
                        CONFIGURAR VERSIONES DE APP
                    </v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="getData">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12" lg="10">
                <v-card>
                    <v-progress-linear indeterminate fixed v-if="loading" style="top:0"/>
                    <v-form ref="form" v-model="valid" @submit.prevent="submit" lazy-validation>
                        <v-card-text>
                            <v-alert dense text type="info" class="mb-6">
                                Los clientes con build menor al minimo veran la pantalla de actualizacion antes de cargar la app.
                            </v-alert>

                            <v-row>
                                <v-col cols="12" md="5">
                                    <v-text-field
                                        v-model="form.title"
                                        label="Titulo del aviso"
                                        prepend-icon="mdi-cellphone-arrow-down"
                                        :rules="[rules.req('title')]"
                                        :error-messages="errors.title"
                                        :disabled="loading"
                                        @input="clearErrors('title')"/>
                                </v-col>
                                <v-col cols="12" md="7">
                                    <v-text-field
                                        v-model="form.message"
                                        label="Mensaje del aviso"
                                        prepend-icon="mdi-message-alert"
                                        :rules="[rules.req('message')]"
                                        :error-messages="errors.message"
                                        :disabled="loading"
                                        @input="clearErrors('message')"/>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="6" v-for="platform in platforms" :key="platform.key">
                                    <v-card outlined class="fill-height">
                                        <v-card-title class="align-center">
                                            <v-icon color="primary" class="mr-2">{{ platform.icon }}</v-icon>
                                            {{ platform.label }}
                                            <v-spacer/>
                                            <v-chip small :color="form[platform.key].enabled ? 'success' : 'grey'" text-color="white">
                                                {{ form[platform.key].enabled ? 'Activo' : 'Inactivo' }}
                                            </v-chip>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row dense>
                                                <v-col cols="12" sm="6">
                                                    <v-switch
                                                        v-model="form[platform.key].enabled"
                                                        label="Controlar version"
                                                        color="primary"
                                                        :disabled="loading"/>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-switch
                                                        v-model="form[platform.key].force_update"
                                                        label="Actualizacion obligatoria"
                                                        color="primary"
                                                        :disabled="loading"/>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model="form[platform.key].current_version"
                                                        label="Version publicada"
                                                        prepend-icon="mdi-tag"
                                                        :error-messages="errors[platform.key + '.current_version']"
                                                        :disabled="loading"
                                                        @input="clearErrors(platform.key + '.current_version')"/>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model.number="form[platform.key].current_build"
                                                        label="Build publicado"
                                                        prepend-icon="mdi-numeric"
                                                        type="number"
                                                        min="1"
                                                        :rules="[positiveRule]"
                                                        :error-messages="errors[platform.key + '.current_build']"
                                                        :disabled="loading"
                                                        @input="clearErrors(platform.key + '.current_build')"/>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-text-field
                                                        v-model.number="form[platform.key].minimum_build"
                                                        label="Build minimo permitido"
                                                        prepend-icon="mdi-shield-alert"
                                                        type="number"
                                                        min="1"
                                                        :rules="[positiveRule]"
                                                        :error-messages="errors[platform.key + '.minimum_build']"
                                                        :disabled="loading"
                                                        @input="clearErrors(platform.key + '.minimum_build')"/>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-card flat class="pa-3 app-version-rule">
                                                        <div class="caption text-uppercase">Regla actual</div>
                                                        <div class="font-weight-bold">
                                                            &lt; {{ form[platform.key].minimum_build || 1 }} debe actualizar
                                                        </div>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field
                                                        v-model="form[platform.key].store_url"
                                                        label="URL de la tienda"
                                                        prepend-icon="mdi-store"
                                                        :rules="[rules.req(platform.key + '.store_url')]"
                                                        :error-messages="errors[platform.key + '.store_url']"
                                                        :disabled="loading"
                                                        @input="clearErrors(platform.key + '.store_url')"/>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn type="submit" color="success" :loading="loading" :disabled="loading || !valid">
                                <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import Form from "../../../helpers/form";

export default {
    name: "configAppVersion",
    mixins: [Form],
    props: ['user'],
    data: () => ({
        loading: true,
        valid: true,
        platforms: [
            {key: 'android', label: 'Android', icon: 'mdi-android'},
            {key: 'ios', label: 'iOS', icon: 'mdi-apple-ios'}
        ],
        form: {
            title: '',
            message: '',
            android: {
                enabled: true,
                force_update: true,
                current_version: '',
                current_build: 1,
                minimum_build: 1,
                store_url: ''
            },
            ios: {
                enabled: true,
                force_update: true,
                current_version: '',
                current_build: 1,
                minimum_build: 1,
                store_url: ''
            }
        }
    }),
    computed: {
        positiveRule() {
            return value => Number(value) > 0 || 'Debe ser mayor a cero.';
        }
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/settings/app/versions').then(res => {
                this.applySettings(res.data.settings || {});
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible cargar versiones.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        applySettings(settings) {
            this.form.title = settings.title || '';
            this.form.message = settings.message || '';
            this.applyPlatform('android', settings.android || {});
            this.applyPlatform('ios', settings.ios || {});
        },
        applyPlatform(key, settings) {
            this.form[key] = Object.assign({}, this.form[key], {
                enabled: settings.enabled !== false,
                force_update: settings.force_update !== false,
                current_version: settings.current_version || '',
                current_build: Number(settings.current_build || 1),
                minimum_build: Number(settings.minimum_build || 1),
                store_url: settings.store_url || ''
            });
        },
        submit() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;
            axios.post('/api/settings/app/versions', this.form).then(res => {
                this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                this.applySettings(res.data.settings || {});
            }).catch(err => {
                this.handleErrors(err.response && err.response.data ? err.response.data.errors : {});
                this.$toast.error(this.errorMessage(err, 'No fue posible guardar versiones.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        errorMessage(err, fallback) {
            if (err.response && err.response.data && err.response.data.status) {
                return err.response.data.status;
            }

            return fallback;
        }
    }
}
</script>

<style scoped>
.app-version-rule {
    border: 1px solid rgba(0, 0, 0, .08);
    background: rgba(13, 147, 165, .08);
}
</style>
